import { useCallback, useEffect, useState } from "react";
import { getUserListRequest } from "../network";

export const useUserList = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [userList, setUserList] = useState<any>([]);

  const getUserList = useCallback(async () => {
    setLoading(true);
    const res = await getUserListRequest();
    setUserList(res.data?.filter((u) => !!u.name).reverse());
    setLoading(false);
    return res;
  }, []);

  useEffect(() => {
    getUserList();
  }, []);

  return { userList, loading };
};
